(function($) {
	
    'use strict';
    
    var utils_recaptcha2, tools_validateForm;
    
    var deleteJobFile = function() {
        var t = $(this);

        t.closest('.element-to-hide').fadeOut(function() {
            $(this).remove();
        });
        t.closest('form').append('<input type="hidden" name="' + t.attr('data-name') + '" value="true"/>');
    };
    
    var validateJobOffer = function (captcha) {
        var $btn = $(this);
        var $form = $btn.closest('form');
        
        // Set the captcha value to input
        $form.find("input[name='captcha']").addClass('required').val(typeof captcha === 'string' ? captcha : 'undefined');
        // Validate required fields
        tools_validateForm($btn);
        // Reset if there is any error
        if ($form.hasClass('has-error') && captcha) {
            grecaptcha.reset($btn.attr('data-widget-id'));
        }
    };

	var init = function () {
        utils_recaptcha2 = Fw.component.models().utils.recaptcha2;
        tools_validateForm = Fw.component.models().tools.validateForm;
        
        $('.delete-job-posting-file').click(deleteJobFile);
        
        $('.job-offer-next-btn').each(function () {
            utils_recaptcha2(this, validateJobOffer);
        });
	};
	
	$(window).ready(init);
	
})(jQuery);
